import { useState, useEffect, useRef, useCallback, useMemo } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-balham.css";
import { AgGridReact } from "ag-grid-react";
import _ from "lodash";
import "./style.css";
import {
  ColumnResizedEvent,
  FilterChangedEvent,
  FilterModifiedEvent,
  GridApi,
} from "ag-grid-community";
import "ag-grid-enterprise";
import Customtooltip from "../../../components/CustomTooltip/index";
import { onGridSizeChanged } from "../../../components/AgGrid/grid-util";
import { useLocation } from "react-router";
import { constants } from "../../../common/constants";
import { LoanRetunsColumnDefs } from "../../../common/LoanRetunsColumnDefs";
import "../style.css";
import "../../../common/style.css";
import { getRowStyle } from "../../../common/commonFunctions";

interface AgGridProps {
  title?: string;
  rowData: any;
  applyLoanMetricsFilters: any;
  height?: any;
  type?: string;
  onClickHan?: any;
  onClickSelectData?: any;
  onCellChange?: any;
  seTtotalSelectedRows?: any;
  getBtnRef?: any;
  getGridApi?: any;
  doesExternalFilterPass?: any;
  isExternalFilterPresent?: any;
  isDeselectAll?: boolean;
  globalSearch?: any;
  isSingleRowInserted?: boolean;
  defaultFilter?: any;
  onRowSelected: any;
  appliedFilterStateCallbackGrid?: any;
  filters?: any;
  settledCount: any;
  unsettledCount: any;
  allocatedCount: any;
  unallocatedCount: any;
  isResetFilters: boolean;
  onDataLoaded: any;
  insertRowId: any[];
}

const LoanReturnsGrid = ({
  title,
  rowData,
  applyLoanMetricsFilters,
  height,
  type,
  onClickHan,
  onClickSelectData,
  onCellChange,
  seTtotalSelectedRows,
  getBtnRef,
  getGridApi,
  doesExternalFilterPass,
  isExternalFilterPresent,
  isDeselectAll,
  globalSearch,
  isSingleRowInserted,
  defaultFilter,
  onRowSelected,
  appliedFilterStateCallbackGrid,
  filters,
  settledCount,
  unsettledCount,
  allocatedCount,
  unallocatedCount,
  // isDataLoaded,
  onDataLoaded,
  isResetFilters,
  insertRowId,
}: // onBtExport,
AgGridProps) => {
  const gridRef = useRef<any>(null);
  const [columnDefs] = useState<any>([...LoanRetunsColumnDefs]);
  const [isSettledFilterActive, setIsSettledFilterActive] = useState(false);
  const [isUnsettledFilterActive, setIsUnsettledFilterActive] = useState(false);
  const [isAllocatedFilterActive, setIsAllocatedFilterActive] = useState(false);
  const [isUnallocatedFilterActive, setIsUnallocatedFilterActive] =
    useState(false);
  const [flashedRowIds, setFlashedRowIds] = useState<any>([]);

  let gridApi: any;
  const defaultColDef = useMemo<any>(() => {
    return {
      flex: 1,
      sortable: true,
      filter: true,
      floatingFilter: false,
      suppressFilterButton: false,
      editable: true,
      resizable: true,
      headerCheckboxSelectionFilteredOnly: true,
      tooltipComponent: Customtooltip,
      menuTabs: [constants.FilterMenuTab],
      tooltipShowDelay: 10,
      tooltipMouseTrack: true,
      suppressKeyboardEvent: (params: any) => {
        let isTabKey = params?.event?.key === constants.Tab;
        if (isTabKey) gridRef?.current?.api?.stopEditing();
        return false;
      },
    };
  }, []);

  useEffect(() => {
    gridApi = gridRef.current!.api;
    var gridColumnApi = gridRef.current!.columnApi;
    getUpdatedData(rowData);
    getBtnRef(gridRef);
    getName(gridApi, gridColumnApi);
  }, [rowData]);
  const onColumnResized = useCallback((params: ColumnResizedEvent) => {}, []);

  const getUpdatedData = useCallback(
    async (data: any) => {
      await gridApi?.applyTransactionAsync({ update: [rowData] });
      if (gridRef && gridRef?.current && gridRef?.current!.api) {
        if (insertRowId && insertRowId?.length > 0) {
          const rowNodes: any[] = [];
          insertRowId?.forEach((id: any, index: number) => {
            const rowNode = gridRef?.current?.api?.getRowNode(id);
            if (rowNode && !_.includes(flashedRowIds, id)) {
              rowNodes.push(rowNode);
            } else {
              const rowNode =
                gridRef?.current?.api?.getDisplayedRowAtIndex(index);
              if (rowNode) rowNodes.push(rowNode);
            }
          });
          setFlashedRowIds((previousIds: any) => [insertRowId, ...previousIds]);
          gridApi?.flashCells({ rowNodes: rowNodes });
        }
        gridRef.current!.api.refreshCells();
      }
      gridRef.current!.api.refreshCells();
    },
    [rowData]
  );

  useEffect(() => {
    if (defaultFilter && gridRef) {
      const filterComponent = gridRef?.current?.api?.getFilterInstance(
        defaultFilter.column
      );
      if (filterComponent) {
        filterComponent?.setModel({ values: defaultFilter.values });
        gridApi.onFilterChanged();
      }
    }
  }, [gridRef]);

  const onGridReady = (params: any) => {
    params.api.sizeColumnsToFit();
    gridApi = params.api;

    var gridColumnApi = params.columnApi;
    // Emmits the gridApi refrence to the parent component
    if (getGridApi) {
      getGridApi(gridApi, gridColumnApi);
    }
  };

  /**
   * Executes whenever Grid/Table filter modifies - this is more sensitive
   * @param params
   */
  const onFilterModified = (params: FilterModifiedEvent) => {
    const { api, columnApi } = params;
  };

  /**
   * Executes whenever Grid/Table filter changes
   * @param params
   */
  const onFilterChanged = (params: FilterChangedEvent) => {
    const { api, columnApi } = params;
    appliedFilterStateCallbackGrid(api?.getFilterModel());
    getName(api, columnApi);
  };

  const { pathname } = useLocation();
  /**
   * To skip pinned rows on the basis of Page path
   * @returns shouldSkip : boolean
   */
  const skipPinnedRow = (): boolean => {
    if (pathname && typeof pathname === "string") {
      const pathsToSkip = ["secmaster", "counterParty"];
      for (let aPath of pathsToSkip) {
        if (pathname.endsWith(aPath)) return true;
      }
    }

    //Skip for Contract Activity Popup
    if (type === constants.ContractActivity) return true;

    return false;
  };

  // useEffect(()=>{
  //   if(gridRef && gridRef?.current && gridRef?.current?.api && gridRef?.current?.api.getDisplayedRowAtIndex(0)!){
  //   const selected: IRowNode[] = [];
  //       selected.push(gridRef?.current?.api.getDisplayedRowAtIndex(0)!);
  //       gridRef?.current?.api.setNodesSelected({ nodes: selected, newValue: true });
  //   }
  // },[isDataLoaded]);

  useEffect(() => {
    let gridRefApi = gridRef?.current!.api;
    gridRefApi?.setFilterModel?.(null);
    setIsAllocatedFilterActive(false);
    setIsUnallocatedFilterActive(false);
    setIsSettledFilterActive(false);
    setIsUnsettledFilterActive(false);
    gridRefApi?.deselectAll?.();
  }, [isResetFilters]);

  const getName = (api: any, columnApi: any) => {
    if (!api || !columnApi || skipPinnedRow()) return;
    let rows: any = {};
    var result = [];
    columnApi?.getAllGridColumns().forEach((item: any) => {
      rows[item.colId] = null;
    });
    let columnsWithAggregation = [
      "return_amount",
      "return_quantity",
      "callback_quantity",
      "callback_amount",
    ];
    columnsWithAggregation.forEach((element) => {
      api?.forEachNodeAfterFilter((rowNode: any) => {
        if (rowNode && rowNode.data && rowNode.data[element]) {
          rows[element] += Number(parseFloat(rowNode.data[element]));
        }
      });
    });
    let contractIdTotal = ["contract_id"];
    let countContractId_ = 0;
    contractIdTotal.forEach((element) => {
      api?.forEachNodeAfterFilter((rowNode: any) => {
        countContractId_++;
        if (rowNode && rowNode.data && rowNode.data[element]) {
          rows[element] += Number(parseFloat(rowNode.data[element]));
        }
      });
    });
    rows["contract_id"] = countContractId_;

    let countAccountId_ = 0;
    api?.forEachNodeAfterFilter((rowNode: any) => {
      if (_.isUndefined(rowNode.aggData)) {
        countAccountId_++;
      }
    });
    rows["account_id"] = countAccountId_;

    var count = Number(2);
    for (var i = 0; i < count; i++) {
      if (i === 0) {
        result.push({
          select: "Selected",
          cpty_name: "CPTY",
          cpty_id: "CPTY",
          div: null,
          quantity: null,
          mark: undefined,
          cusip: null,
          ticker_price: null,
          tb_ticker: "Symbol",
          ticker: "Symbol",
          value: "Value",
          contract_value: "Value",
          daily_accrual: "Accrual",
          // contract_price: "Total Price",
          daily_accruals: "Accrual",
          recall: "Recall",
          recall_date: null,
          exp_date: null,
          c_n: null,
          // Collatoral_code: "Total Collatoral",
          contract_id: "Contracts",
          isTotalRow: true,
          account_id: "Rows",
          return_quantity: "Return Qty",
          callback_quantity: "Callback Qty",
          return_amount: "Return Value",
          callback_amount: "Callback Value",
          // rate: "Avg Rate",
        });
      } else {
        rows["isTotalRow"] = true;
        rows["tb_ticker"] = countUnique("tb_ticker", api);
        rows["ticker"] = countUnique("ticker", api);
        // rows["tb_ticker"] = countTBTICKER();
        // rows["ticker"] = countTBTICKER();
        // rows["Collatoral_code"] = countColla();
        rows["cpty_id"] = countUnique("cpty_id", api);
        //const selectedRows = gridRef.current!.api.getSelectedRows();
        //rows["select"] = countUnique('select',api);
        rows["select"] = countRows("select", api);
        // rows["cpty_name"] = countCPTY();
        // rows["contract_id"] = countContractId();
        rows["recall"] = countRecall();
        // rows["rate"] = countRate();
        rows["mark"] = undefined;
        result.push(rows);
      }
    }
    api?.setPinnedBottomRowData(result);
  };

  /**
   * Method counts the unique value for given attribute (for filtered values also)
   * @param attribute
   * @returns unique values count
   */
  const countUnique = (attribute: string, api: GridApi): number => {
    const uniqueItemsSet: Set<any> = new Set();
    api?.forEachNodeAfterFilter((rowNode: any) => {
      if (rowNode?.data instanceof Object && attribute in rowNode.data && !_.isEmpty(rowNode.data[attribute])) {
        uniqueItemsSet.add(rowNode.data[attribute]);
      }
    });
    return uniqueItemsSet.size;
  };

  useEffect(() => {
    if (isDeselectAll != undefined) gridRef.current?.api?.deselectAll();
  }, [isDeselectAll]);

  const countRows = (rowNode: any, api: GridApi): number => {
    const selectedRows: any = gridRef.current!.api.getSelectedRows();
    if (selectedRows.length === 0) {
      return 0;
    } else {
      return selectedRows.length;
    }
  };

  const countRecall = () => {
    const rowData: any = [];
    const recallCount = new Set();
    gridApi?.forEachNode((node: any) => rowData.push(node.data));
    rowData.map((obj: any) => {
      if (obj) {
        recallCount.add(obj.recall);
      }
    });
    return recallCount.size;
  };

  const rowClassRules = useMemo(() => {
    return {
      "is-new-warning": (params: any) => {
        var isNew = params && params.data && params.data.is_new;
        return isNew === "TRUE";
      },
      "is-new-recall": (params: any) => {
        var isNew = params && params.data && params.data.is_Recall;
        return isNew === "True";
      },
    };
  }, []);

  const onSelectionChanged = useCallback((params: any) => {
    const selectedRows = gridRef.current!.api.getSelectedNodes();
    if (!_.isEmpty(selectedRows)) {
      if (selectedRows[0]?.allLeafChildren) {
        onRowSelected(
          selectedRows[0]?.allLeafChildren[0]?.data?.ticker,
          selectedRows[0]?.allLeafChildren[0]?.data?.cusip
        );
      } else if (selectedRows[0].data.cusip)
        onRowSelected(selectedRows[0].data.cusip, selectedRows[0]?.data?.id);
    }
  }, []);

  const onCellValueChanged = useCallback((event: any) => {
    let updateArray: any = [];
    event.value = event.value.toUpperCase();
    onCellChange(event.data, event.value, event.column);
    updateArray.push(event.data);

    gridApi = gridRef.current!.api;
    var gridColumnApi = gridRef.current!.columnApi;
    gridApi?.applyTransaction({ update: updateArray });

    var params = {
      force: true,
      suppressFlash: true,
      columns: [event.column],
    };
  }, []);

  const autoGroupColumnDef = useMemo(() => {
    return {
      minWidth: 150,
      maxWidth: 300,
    };
  }, []);

  const getRowId = useMemo(() => {
    return (params: any) =>
      (params.data.callbacks_id ? params.data.callbacks_id.toString() : "") +
      (params.data.activity_id ? params.data.activity_id.toString() : "");
  }, []);

  function makeid(length: any) {
    let result = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

  const sideBar = useMemo(() => {
    return {
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          labelKey: "columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
          toolPanelParams: {
            suppressRowGroups: true,
            suppressValues: true,
            suppressPivots: true,
            suppressPivotMode: true,
            suppressColumnFilter: false,
            suppressColumnSelectAll: false,
            suppressColumnExpandAll: true,
          },
        },
      ],
      defaultToolPanel: "",
    };
  }, []);

  function isForceRefreshSelected() {
    return (document.querySelector("#forceRefresh") as HTMLInputElement)
      ?.checked;
  }
  function isSuppressFlashSelected() {
    return (document.querySelector("#suppressFlash") as HTMLInputElement)
      ?.checked;
  }
  const onGridRowDataChanged = (params: any) => {
    let refreshParams: any = {
      force: isForceRefreshSelected(),
      suppressFlash: isSuppressFlashSelected(),
    };
    gridRef.current!.api.refreshCells(refreshParams);
    setTimeout(() => {
      if (gridRef && gridRef?.current && gridRef?.current!.api) {
        if (filters) {
          if (gridApi?.getFilterModel() !== filters)
            gridApi?.setFilterModel(filters);
        }
      }
    }, 500);
  };

  const getContextMenuItems = useCallback((params: any) => {
    var result = [
      {
        name: "Expand All",
        action: () => {
          expandAll();
        },
      },
      {
        name: "Collapse All",
        action: () => {
          collapseAll();
        },
      },
      "copy",
      "copyWithHeaders",
      "copyWithGroupHeaders",
      "paste",
      "export",
    ];
    return result;
  }, []);

  const expandAll = useCallback(() => {
    gridRef.current!.api.expandAll();
  }, []);

  const collapseAll = useCallback(() => {
    gridRef.current!.api.collapseAll();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      filterMetricRows();
    }, 800);
  }, [
    isAllocatedFilterActive,
    isUnallocatedFilterActive,
    isSettledFilterActive,
    isUnsettledFilterActive,
  ]);

  const filterMetricRows = () => {
    let filters = {
      isAllocatedFilterActive: isAllocatedFilterActive,
      isUnallocatedFilterActive: isUnallocatedFilterActive,
      isSettledFilterActive: isSettledFilterActive,
      isUnsettledFilterActive: isUnsettledFilterActive,
    };
    applyLoanMetricsFilters?.(filters);
  };
  const onAllocateFilter = (isAllocatedSelected: boolean = false) => {
    if (isAllocatedSelected) {
      if (!isAllocatedFilterActive && isUnallocatedFilterActive) {
        setIsUnallocatedFilterActive(false);
      }
      setIsAllocatedFilterActive(!isAllocatedFilterActive);
    } else {
      if (!isUnallocatedFilterActive && isAllocatedFilterActive) {
        setIsAllocatedFilterActive(false);
      }
      setIsUnallocatedFilterActive(!isUnallocatedFilterActive);
    }
  };

  const onSettledFilter = (isSettledSelected: boolean = false) => {
    if (isSettledSelected) {
      if (!isSettledFilterActive && isUnsettledFilterActive) {
        setIsUnsettledFilterActive(false);
      }
      setIsSettledFilterActive(!isSettledFilterActive);
    } else {
      if (!isUnsettledFilterActive && isSettledFilterActive) {
        setIsSettledFilterActive(false);
      }
      setIsUnsettledFilterActive(!isUnsettledFilterActive);
    }
  };

  const onCellFocused = (event: any) => {
    if (
      event &&
      !_.isUndefined(event?.rowIndex) &&
      !_.isNull(event?.rowIndex)
    ) {
      let rowNode = gridRef?.current?.api?.getDisplayedRowAtIndex(
        event?.rowIndex
      );
      if (rowNode && event?.rowPinned !== "bottom") {
        const selected: any = [];
        selected.push(rowNode);
        gridRef?.current?.api?.setNodesSelected({
          nodes: selected,
          newValue: true,
        });
      }
    }
  };

  const onColumnRowGroupChanged = (event: any) => {
    gridApi = gridRef.current!.api;
    var gridColumnApi = gridRef.current!.columnApi;
    getName(gridApi, gridColumnApi);
  };

  useEffect(() => {
    let refreshParams: any = {
      force: true,
      suppressFlash: true,
    };
    gridRef?.current!.api?.refreshCells(refreshParams);
  }, [globalSearch]);

  const onFirstDataRendered = () => {
    let gridRefApi = gridRef?.current!.api;
    var headerDivs = document.getElementsByClassName("ag-header-cell");
    if (headerDivs && !_.isEmpty(headerDivs)) {
      (headerDivs[0] as HTMLElement).focus();
    }
    var gridColumnApi = gridRef?.current!.columnApi;
    getName(gridRefApi, gridColumnApi);
  };

  return (
    <>
      {title !== undefined && (
        <div
          style={{
            height: "2%",
            paddingLeft: "0.2rem",
            paddingTop: "0.8rem",
            paddingBottom: "0.8rem",
          }}
          className="drag-handle title-subHeaderTitle"
        >
          {title}
        </div>
      )}

      <div
        className="w-100 d-flex align-items-center ps-0"
        style={{ height: "3%", marginTop: 2, marginBottom: 2 }}
      >
        <div className="float-start flex h-100 align-items-center">
          <div className="d-flex h-100 align-items-center flex-row">
            <div className="ms-1 h-100 d-flex align-items-center metrics-div">
              <button
                type="button"
                onClick={() => {
                  onAllocateFilter(true);
                }}
                className={`metrics-btn p-1 h-75 d-flex align-items-center btn btn-allocated ${
                  isAllocatedFilterActive ? "btn btn-filter-active" : ""
                }`}
              >
                Allocated ({allocatedCount})
              </button>
            </div>
            <div className="ms-2 d-flex h-100 align-items-center metrics-div">
              <button
                type="button"
                onClick={() => {
                  onAllocateFilter();
                }}
                className={`metrics-btn p-1 h-75 d-flex btn btn-unallocated align-items-center ${
                  isUnallocatedFilterActive ? "btn btn-filter-active" : ""
                }`}
              >
                Unallocated ({unallocatedCount})
              </button>
            </div>
            <div className="ms-2 d-flex align-items-center h-100 metrics-div">
              <button
                type="button"
                onClick={() => {
                  onSettledFilter(true);
                }}
                className={`metrics-btn p-1 d-flex h-75 align-items-center btn btn-settled ${
                  isSettledFilterActive ? "btn btn-filter-active" : ""
                }`}
              >
                Settled ({settledCount})
              </button>
            </div>
            <div className="ms-2 d-flex align-items-center h-100 metrics-div">
              <button
                type="button"
                onClick={() => {
                  onSettledFilter();
                }}
                className={`metrics-btn p-1 d-flex align-items-center h-75 btn btn-unsettled ${
                  isUnsettledFilterActive ? "btn btn-filter-active" : ""
                }`}
              >
                Unsettled ({unsettledCount})
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="ag-theme-balham" style={{ height: "88.5%" }}>
        <AgGridReact
          ref={gridRef}
          rowStyle={{
            justifyContent: "center",
            color: "#2D2D2D",
            fontSize: "0.75rem",
            fontWeight: "400",
            fontStyle: "normal",
          }}
          rowHeight={22}
          rowGroupPanelShow="always"
          rowSelection={"single"}
          columnDefs={columnDefs}
          onFirstDataRendered={onFirstDataRendered}
          getRowId={getRowId}
          onRowDataUpdated={onGridRowDataChanged}
          rowData={rowData}
          suppressRowClickSelection={true}
          defaultColDef={defaultColDef}
          suppressAggFuncInHeader={true}
          enableCellChangeFlash={
            _.isUndefined(isSingleRowInserted) || !isSingleRowInserted
          }
          enableRangeSelection={true}
          onGridReady={onGridReady}
          onFilterModified={onFilterModified}
          onFilterChanged={onFilterChanged}
          onColumnRowGroupChanged={onColumnRowGroupChanged}
          onGridSizeChanged={onGridSizeChanged}
          onColumnResized={onColumnResized}
          rowClassRules={rowClassRules}
          onSelectionChanged={onSelectionChanged}
          getRowStyle={getRowStyle}
          onCellValueChanged={onCellValueChanged}
          autoGroupColumnDef={autoGroupColumnDef}
          groupSelectsChildren={false}
          sideBar={sideBar}
          pivotMode={false}
          onCellFocused={onCellFocused}
          cacheQuickFilter={false}
          getContextMenuItems={getContextMenuItems}
          quickFilterText={globalSearch}
          overlayLoadingTemplate={
            '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
          }
        ></AgGridReact>
      </div>
    </>
  );
};

function CustomTooltip() {}

CustomTooltip.prototype.init = function (params: any) {
  var type = params.type || "primary";
  var data = params.api.getDisplayedRowAtIndex(params.rowIndex).data;
  var eGui = (this.eGui = document.createElement("div"));

  eGui.classList.add("custom-tooltip");
  this.eGui.innerHTML =
    '<div class="panel panel-' +
    type +
    '">' +
    '<div class="panel-heading">' +
    '<h3 class="panel-title">' +
    data.country +
    "</h3>" +
    "</div>" +
    '<div class="panel-body">' +
    '<h4 style="white-space: nowrap;">' +
    data.athlete +
    "</h4>" +
    "<p>Total: " +
    data.total +
    "</p>" +
    "</div>" +
    "</div>";
};

CustomTooltip.prototype.getGui = function () {
  return this.eGui;
};

export default LoanReturnsGrid;
